import React, { useState, useEffect } from 'react';
import { carsAPI } from '../services/api';
import './VariantSelector.css';

const VariantSelector = ({ modelKey, onSelectVariant }) => {
  const [variants, setVariants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (modelKey) {
      fetchVariants();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modelKey]);

  const fetchVariants = async () => {
    try {
      setLoading(true);
      const response = await carsAPI.getModelVariants(modelKey);
      // Django REST Framework returns data in results when pagination is enabled
      const data = response.data.results || response.data;
      setVariants(Array.isArray(data) ? data : []);
      setError(null);
    } catch (err) {
      setError('فشل في تحميل السيارات');
      console.error('Error fetching variants:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="spinner"></div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="variant-selector">
      <h2 className="section-title">اختر سيارتك</h2>
      <div className="variants-grid">
          {variants.map((variant) => (
          <div
            key={variant.id}
            className="variant-card card"
            onClick={() => onSelectVariant(variant)}
          >
            <div className="variant-image-wrapper">
              {(variant.image_url || variant.image_front_url) ? (
                <img
                  src={variant.image_url || variant.image_front_url}
                  alt={variant.name}
                  className="variant-image"
                  onError={(e) => {
                    e.target.src = '/logo.png';
                  }}
                />
              ) : (
                <div className="variant-image-placeholder">
                  <span className="placeholder-icon">🚗</span>
                  <span className="placeholder-text">{variant.name}</span>
                </div>
              )}
            </div>
            <div className="variant-info">
              <h3 className="variant-name">{variant.name}</h3>
              {variant.variant_type && (
                <p className="variant-type">{variant.variant_type}</p>
              )}
              {variant.parts_count > 0 && (
                <p className="variant-parts">
                  {variant.parts_count} جزء متاح
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VariantSelector;
